/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { Component, cloneElement } from 'react';
import PropTypes from "prop-types";
export class CustomItemAction extends Component {
  mounted;
  constructor(props) {
    super(props);
    this.state = {
      hasFocus: false
    };

    // while generally considered an anti-pattern, here we require
    // to do that as the onFocus/onBlur events of the action controls
    // may trigger while this component is unmounted. An alternative
    // (at least the workarounds suggested by react is to unregister
    // the onFocus/onBlur listeners from the action controls... this
    // unfortunately will lead to unnecessarily complex code... so we'll
    // stick to this approach for now)
    this.mounted = false;
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  onFocus = () => {
    if (this.mounted) {
      this.setState({
        hasFocus: true
      });
    }
  };
  onBlur = () => {
    if (this.mounted) {
      this.setState({
        hasFocus: false
      });
    }
  };
  hasFocus = () => {
    return this.state.hasFocus;
  };
  render() {
    const {
      action,
      enabled,
      item,
      className
    } = this.props;
    const tool = action.render(item, enabled);
    const clonedTool = cloneElement(tool, {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    const style = this.hasFocus() ? {
      opacity: 1
    } : undefined;
    return <div style={style} className={className}>
        {clonedTool}
      </div>;
  }
}
CustomItemAction.propTypes = {
  action: PropTypes.any.isRequired,
  enabled: PropTypes.bool.isRequired,
  item: PropTypes.any.isRequired,
  className: PropTypes.string.isRequired,
  index: PropTypes.number
};
try {
  CustomItemAction.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/basic_table/custom_item_action.tsx',
    description: '',
    displayName: 'CustomItemAction',
    methods: [],
    props: {
      action: {
        defaultValue: null,
        description: '',
        name: 'action',
        parent: {
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        }],
        required: true,
        type: {
          name: 'CustomItemAction<T>'
        }
      },
      enabled: {
        defaultValue: null,
        description: '',
        name: 'enabled',
        parent: {
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      item: {
        defaultValue: null,
        description: '',
        name: 'item',
        parent: {
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        }],
        required: true,
        type: {
          name: 'T'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      index: {
        defaultValue: null,
        description: '',
        name: 'index',
        parent: {
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/custom_item_action.tsx',
          name: 'CustomItemActionProps'
        }],
        required: false,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['CustomItemActionProps']
  };
} catch (e) {}